<script>
const host = 'https://api.fams.tech';
// const host = 'http://127.0.0.1:9002';
export default {
  host
};
</script>
